function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-6.914-12.422a.352.352,0,0,0-.352.352v4.219a.352.352,0,0,0,.352.352H-2.7a.352.352,0,0,0,.352-.352v-.293A.352.352,0,0,0-2.7-8.5h-2.88A6.268,6.268,0,0,1,0-11.895a6.269,6.269,0,0,1,6.27,6.27A6.269,6.269,0,0,1,0,.645,6.245,6.245,0,0,1-4.193-.963a.351.351,0,0,0-.483.013l-.207.207a.352.352,0,0,0,.014.511A7.239,7.239,0,0,0,0,1.641,7.266,7.266,0,0,0,7.266-5.613,7.282,7.282,0,0,0,.023-12.891,7.262,7.262,0,0,0-6.27-9.3V-12.07a.352.352,0,0,0-.352-.352ZM2.509-3.186l.138-.19a.352.352,0,0,0-.078-.491L.469-5.395V-9.727a.352.352,0,0,0-.352-.352H-.117a.352.352,0,0,0-.352.352v4.809L2.018-3.109A.352.352,0,0,0,2.509-3.186Z",
  transform: "translate(7.266 12.891)",
  opacity: 0.871
});

var SvgIconSide16 = function SvgIconSide16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.531,
    height: 14.531,
    viewBox: "0 0 14.531 14.531",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSide16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-side-16.2926c3a0.svg";
export { ForwardRef as ReactComponent };